import { useTranslation } from 'react-i18next'

import { Widget } from '../../../../Widget'
import { QA_NAME_LISTING_PROFILE_WIDGET_ADDRESS } from '../RentalPortalListingProfile.constants'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'

import { ListingProfileWidgetAddressContent } from './ListingProfileWidgetAddressContent'
import { getListingAddressActionsProps } from './RentalPortalListingProfileWidgetAddress.utils'

import * as styles from './RentalPortalListingProfileWidgetAddress.module.css'

function RentalPortalListingProfileWidgetAddress() {
  const { t } = useTranslation()

  const { isInitiated, listingData } = useListingProfileContext()

  return (
    <Widget
      contentContainerProps={{
        className: styles.content,
        skeletonProps: { className: styles.skeleton },
      }}
      headerProps={{
        contentProps: {
          actionsProps: getListingAddressActionsProps(listingData),
        },
      }}
      isSkeleton={!isInitiated || !listingData}
      qaName={QA_NAME_LISTING_PROFILE_WIDGET_ADDRESS}
      title={t('RentalPortal.ListingProfileAddressWidgetTitleKey')}
    >
      <ListingProfileWidgetAddressContent />
    </Widget>
  )
}

export default RentalPortalListingProfileWidgetAddress
